



import React, { memo, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { getCountdown } from "../helper/Countdown";
import handleAddToCart from "./addtocartfunction"; // Import the add to cart function
const API_BASE = process.env.REACT_APP_WC_URL;
// const CK = process.env.REACT_APP_WC_CK;
// const CS = process.env.REACT_APP_WC_CS;

const SampleNextArrow = memo(({ className, onClick }) => (
    <button
        type="button"
        onClick={onClick}
        className={`${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
        <i className="ph ph-caret-right" />
    </button>
));

const SamplePrevArrow = memo(({ className, onClick }) => (
    <button
        type="button"
        onClick={onClick}
        className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
        <i className="ph ph-caret-left" />
    </button>
));

const HotDealsOne = () => {
    const [timeLeft, setTimeLeft] = useState(getCountdown());
    const [products, setProducts] = useState([]);
    const [category, setCategory] = useState(null);

    useEffect(() => {
        const interval = setInterval(() => setTimeLeft(getCountdown()), 1000);
        return () => clearInterval(interval);
    }, []);

    // 🔥 Fetch Hot Deals Category + Products
    useEffect(() => {

        async function loadHotDeals() {

            try {

                // Fetch all categories (Store API)
                const catRes = await fetch(
                    `https://ecom.brightcodeapp.com/wp-json/wc/store/products/categories`
                );

                const catData = await catRes.json();

                // find category by slug
                const cat = catData.find(
                    (c) => c.slug === "hot-deals-todays"
                );

                if (!cat) {
                    console.error("Category not found");
                    return;
                }

                setCategory(cat);

                // Fetch products by category id
                const prodRes = await fetch(
                    `https://ecom.brightcodeapp.com/wp-json/wc/store/products?category=${cat.id}&per_page=8`
                );

                const prodData = await prodRes.json();

                setProducts(prodData);

            } catch (err) {

                console.error("Hot Deals API Error", err);

            }

        }

        loadHotDeals();

    }, []);



    const settings = {
        dots: false,
        arrows: true,
        infinite: true,
        speed: 1000,
        slidesToShow: 4,
        autoplay: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            { breakpoint: 1399, settings: { slidesToShow: 3 } },
            { breakpoint: 1199, settings: { slidesToShow: 2 } },
            { breakpoint: 575, settings: { slidesToShow: 1 } },
        ],
    };

    return (
        <section className="hot-deals pt-80">
            <div className="container container-lg">
                <div className="section-heading">

                    <div className="flex-between flex-wrap gap-8">
                        <h5 className="mb-0">Hot Deals Todays</h5>

                        <div className="flex-align mr-point gap-16">
                            <Link
                                to="/shop"
                                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                            >
                                All Categories
                            </Link>

                        </div>


                    </div>



                </div>

                <div className="row g-12">
                    <div className="col-md-4">
                        <div className="hot-deals position-relative rounded-16 bg-main-600 overflow-hidden p-28 z-1 text-center">
                            {/* Background shape */}
                            <img
                                src="assets/images/shape/offer-shape.png"
                                alt=""
                                className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100 opacity-6"
                            />

                            {/* Thumbnail */}
                            <div className="hot-deals__thumb">
                                <img src={category?.image?.src || "assets/images/thumbs/hot-deals-img.png"} alt={category?.name || "Hot Deals"} width={"50%"} />
                            </div>

                            <div className="py-xl-4">
                                <h4 className="text-white mb-8">{category?.name || "Hot Deals"}</h4>
                                {/* Countdown */}
                                <div className="countdown my-32" id="countdown4">
                                    <ul className="countdown-list flex-center flex-wrap">
                                        <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                                            <span className="days" />
                                            {timeLeft.days} Days
                                        </li>
                                        <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                                            <span className="hours" />
                                            {timeLeft.hours} Hours
                                        </li>
                                        <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                                            <span className="minutes" />
                                            {timeLeft.minutes} Min
                                        </li>
                                        <li className="countdown-list__item text-heading flex-align gap-4 text-sm fw-medium colon-white">
                                            <span className="seconds" />
                                            {timeLeft.seconds} Sec
                                        </li>
                                    </ul>
                                </div>

                                {/* Shop Now Button */}
                                <Link
                                    to="/shop"
                                    className="mt-16 btn btn-main-two fw-medium d-inline-flex align-items-center rounded-pill gap-8"
                                    tabIndex={0}
                                >
                                    Shop Now
                                    <span className="icon text-xl d-flex">
                                        <i className="ph ph-arrow-right" />
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>


                    <div className="col-md-8">
                        <div className="hot-deals-slider arrow-style-two">
                            <Slider {...settings}>
                                {products.map((p) => (
                                    <div key={p.id}>
                                        <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 position-relative transition-2">
                                            {p.on_sale && (
                                                <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white">
                                                    Sale {Math.round(((p.regular_price - p.sale_price) / p.regular_price) * 100)}%
                                                </span>
                                            )}

                                            <Link to={`/product-details/${p.id}`} className="product-card__thumb flex-center">
                                                <img src={p.images?.[0]?.src} alt={p.name} />
                                            </Link>

                                            <div className="flex-align gap-6">
                                                <span className="text-xs fw-bold text-gray-500">
                                                    {products.average_rating || "0.0"}
                                                </span>
                                                <span className="text-15 fw-bold text-warning-600 d-flex">
                                                    <i className="ph-fill ph-star" />
                                                </span>
                                                <span className="text-xs fw-bold text-gray-500">
                                                    ({products.rating_count || 0})
                                                </span>
                                            </div>

                                            <div className="product-card__content p-sm-2">
                                                <h6 className="title text-lg fw-semibold mt-12 mb-8">
                                                    <Link to={`/product/${p.id}`} className="link text-line-2">
                                                        {p.name}
                                                    </Link>
                                                </h6>

                                                <div className="flex-align gap-4">
                                                    <span className="text-main-600 text-md d-flex">
                                                        <i className="ph-fill ph-storefront" />
                                                    </span>
                                                    <span className="text-gray-500 text-xs">
                                                        By {products.store?.name || "Store"}
                                                    </span>
                                                </div>

                                                <div className="product-card__price mb-8">
                                                    <span className="text-gray-400 text-md fw-semibold text-decoration-line-through ms-8">
                                                        ₹{p.regular_price}
                                                    </span>

                                                    {p.sale_price && (
                                                        <span className="text-heading text-md fw-semibold">
                                                            ₹{p.sale_price || p.price}{" "}
                                                            <span className="text-gray-500 fw-normal">/Qty</span>
                                                        </span>
                                                    )}
                                                </div>

                                                <button
                                                    onClick={() => handleAddToCart(p.id)}
                                                    className="product-card__cart btn btn-main py-11 px-24 rounded-pill flex-align gap-8"
                                                >
                                                    Add To Cart <i className="ph ph-shopping-cart" />
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Slider>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HotDealsOne;
